<template>
  <div class="row">
    <div class="col-md-4 form-group">
      <label>{{ $t('involvedForm.property.type.label') }}</label>
      <select
        v-model="value.property_type"
        class="form-control"
        :disabled="disabled"
      >
        <option value="">
          {{ $t('involvedForm.property.type.select') }}
        </option>
        <option value="casa">
          {{ $t('involvedForm.property.type.options.house') }}
        </option>
        <option value="apartamento">
          {{ $t('involvedForm.property.type.options.apartment') }}
        </option>
        <option value="comercio">
          {{ $t('involvedForm.property.type.options.commerce') }}
        </option>
        <option value="terreno">
          {{ $t('involvedForm.property.type.options.land') }}
        </option>
        <option value="outro">
          {{ $t('involvedForm.property.type.options.other') }}
        </option>
      </select>
    </div>
    <div class="col-md-8 form-group">
      <label>{{ $t('involvedForm.property.address.label') }}</label>
      <input
        v-model="value.address"
        type="text"
        class="form-control"
        :disabled="disabled"
        :placeholder="$t('involvedForm.property.address.placeholder')"
      >
    </div>

    <div class="col-12 form-group">
      <label>{{ $t('involvedForm.property.reference.label') }}</label>
      <input
        v-model="value.reference"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>

    <div class="col-12 form-group">
      <label>{{ $t('involvedForm.property.description.label') }}</label>
      <input
        v-model="value.description"
        type="text"
        class="form-control"
        :disabled="disabled"
        :placeholder="$t('involvedForm.property.description.placeholder')"
      >
    </div>

    <div class="col-12 form-group">
      <label>{{ $t('involvedForm.property.observation.label') }}</label>
      <textarea
        v-model="value.observation"
        class="form-control"
        rows="2"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedPropertyForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
